import { computed, type ComputedRef } from 'vue'

import { useRbac } from '@/features/account'

export interface UseDataConnectorsAccess {
  canView: ComputedRef<boolean>
}

export function useDataConnectorsAccess(): UseDataConnectorsAccess {
  const rbac = useRbac()
  return { canView: computed(() => rbac.hasPermission('ad_metric_integrator')) }
}
